import { FC } from 'react';
import * as React from 'react';
import { ImageType } from './cms-image.types';
import { StyledImage } from './cms-image.styles';

export const CmsImage: FC<
    ImageType & React.ImgHTMLAttributes<HTMLImageElement>
> = (props) => {
    const {
        src,
        width,
        height,
        fit,
        focus,
        quality = 50,
        alt = '',
        ...rest
    } = props;
    if (!src) return null;
    const queryStringParamOperator = src.indexOf('?') > -1 ? '&' : '?';
    let fallbackUrl = src;

    fallbackUrl += `${queryStringParamOperator}q=${quality}`;
    fallbackUrl += width ? `&w=${width}` : '';
    fallbackUrl += height ? `&h=${height}` : '';
    fallbackUrl += fit ? `&fit=${fit}` : '';
    fallbackUrl += focus ? `&f=${focus}` : '';

    const imageUrl = fallbackUrl + '&fm=webp';
    return (
        <picture>
            <source srcSet={imageUrl} type="image/webp" />
            <StyledImage src={fallbackUrl} alt={alt} {...rest} />
        </picture>
    );
};

export default CmsImage;
